import { render, staticRenderFns } from "./Stencil.vue?vue&type=template&id=1b83f2ea"
import script from "./Stencil.vue?vue&type=script&lang=js"
export * from "./Stencil.vue?vue&type=script&lang=js"
import style0 from "./Stencil.vue?vue&type=style&index=0&id=1b83f2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports